import { motion } from 'framer-motion';
import Link from 'next/link';
import { useState } from 'react';
import styled from 'styled-components';
import getPlatform from '../../../common/utils/getPlatform';
import { BrandSitesV2Theme } from '../common/GlobalStyle';
import AppDownloadModal2 from '../../AppDownloadModal2';

export default function HeroSection() {
  const [isAppDownloadModalVisible, setIsAppDownloadModalVisible] = useState(false);

  return (
    <Container>
      <HeroImageWrapper>
        <picture>
          <source
            srcSet="https://cleanhome-web.cleaninglab.co.kr/brandsite/home_clean/webp/hero_mobile.webp"
            type="image/webp"
            media={`(max-width:${BrandSitesV2Theme!.brandSitesV2!.breakpoints.mobile})`}
          />
          <source
            srcSet="https://cleanhome-web.cleaninglab.co.kr/brandsite/home_clean/webp/hero.webp"
            type="image/webp"
          />
          <source
            srcSet="https://cleanhome-web.cleaninglab.co.kr/brandsite/home_clean/hero_mobile.png"
            type="image/png"
            media={`(max-width:${BrandSitesV2Theme!.brandSitesV2!.breakpoints.mobile})`}
          />
          <source srcSet="https://cleanhome-web.cleaninglab.co.kr/brandsite/home_clean/hero.png" type="image/png" />
          <HeroImage
            src="https://cleanhome-web.cleaninglab.co.kr/brandsite/home_clean/hero.png"
            alt=""
            animate={{ scale: [1, 1.04], opacity: [0.9, 1] }}
            transition={{ duration: 0.6, times: [0, 1], ease: [0.65, 0, 0.35, 1] }}
          />
        </picture>
        {/* <HeroImageBlur /> */}
      </HeroImageWrapper>
      <FrontWrapper>
        <Front>
          <TitleWrapper
            initial={{ opacity: 0 }}
            animate={{ y: [10, 10, 0], opacity: [0, 0, 1] }}
            transition={{ duration: 1, times: [0, 0.6, 1], ease: [0.65, 0, 0.35, 1] }}
          >
            <SubTitle>청연 집청소</SubTitle>
            <FakeHeroTitle>청소의 기준, 청소연구소</FakeHeroTitle>
            <TitleDesktop>{TitleDesktopSvg}</TitleDesktop>
            <TitleTablet>{TitleTabletSvg}</TitleTablet>
            {/*<TitleMobile>{TitleMobileSvg}</TitleMobile>*/}
          </TitleWrapper>
          <HeroBottom
            initial={{ opacity: 0 }}
            animate={{ y: [10, 10, 0], opacity: [0, 0, 1] }}
            transition={{ duration: 1.2, times: [0, 0.66, 1], ease: [0.65, 0, 0.35, 1] }}
          >
            <Description>
              {'꼼꼼하게, 신속하게, 매칭까지 정확하게. \n공간에 맞춘 서비스로, 청소의 기준을 만듭니다.'}
            </Description>
            <Link href="https://res.cleaninglab.co.kr/u/web_to_app.html" passHref>
              <Button
                onClick={(e) => {
                  // 모바일이면 href로 이동, PC면 다운로드 팝업 띄우기
                  const platform = getPlatform();

                  if (platform === 'mobile' || platform === 'tablet') return;

                  e.preventDefault();
                  setIsAppDownloadModalVisible(true);
                }}
              >
                앱 다운로드
              </Button>
            </Link>
          </HeroBottom>
        </Front>
      </FrontWrapper>
      <AppDownloadModal2
        visible={isAppDownloadModalVisible}
        setVisible={setIsAppDownloadModalVisible}
        hasBodyScrollLock
      />
    </Container>
  );
}

const Container = styled.section`
  position: relative;
  width: 100%;
  height: 700px;
  /* max-height: 100vh; */

  @media (max-width: ${({ theme }) => theme.brandSitesV2!.breakpoints.tablet}) {
    height: 600px;
  }

  @media (max-width: ${({ theme }) => theme.brandSitesV2!.breakpoints.mobile}) {
    height: 620px;
  }
`;

const HeroImageWrapper = styled.div`
  width: 100%;
  height: 100%;
  overflow: hidden;
`;

const HeroImage = styled(motion.img)`
  width: 100%;
  height: 100%;
  /* max-height: 100vh; */
  object-fit: cover;
  object-position: 66% 30%;

  @media (max-width: ${({ theme }) => theme.brandSitesV2!.breakpoints.tablet}) {
    /* scale: 1.6; */
    /* transform-origin: 70% 10%; */
    /* object-position: 60% 30%; */
  }

  @media (max-width: ${({ theme }) => theme.brandSitesV2!.breakpoints.mobile}) {
    /* scale: 1; */
    object-position: 100% 55%;
    /* transform-origin: 0%; */
  }
`;

const FrontWrapper = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  padding: 0 24px;
`;

const Front = styled.div`
  width: 100%;
  max-width: ${({ theme }) => theme.brandSitesV2!.containerWidths.desktop};
  margin: 0 auto;

  @media (max-width: ${({ theme }) => theme.brandSitesV2!.breakpoints.tablet}) {
    max-width: ${({ theme }) => theme.brandSitesV2!.containerWidths.tablet};
  }

  @media (max-width: ${({ theme }) => theme.brandSitesV2!.breakpoints.mobile}) {
    /* max-width: ${({ theme }) => theme.brandSitesV2!.containerWidths.mobile}; */
  }
`;

const TitleWrapper = styled(motion.div)`
  margin-top: 214px;
  margin-bottom: 26px;

  @media (max-width: ${({ theme }) => theme.brandSitesV2!.breakpoints.tablet}) {
    margin-top: 184px;
    margin-bottom: 28px;
  }

  @media (max-width: ${({ theme }) => theme.brandSitesV2!.breakpoints.mobile}) {
    margin-top: 122px;
    margin-bottom: 24px;
  }
`;

const FakeHeroTitle = styled.h1`
  position: absolute;
  width: 1px;
  height: 1px;
  overflow: hidden;
  margin: -1px;
  clip: rect(0, 0, 0, 0);
  text-indent: -5000px;
`;

const TitleDesktop = styled.div`
  display: block;

  @media (max-width: ${({ theme }) => theme.brandSitesV2!.breakpoints.tablet}) {
    display: none;
  }
`;

const TitleTablet = styled.div`
  display: none;

  @media (max-width: ${({ theme }) => theme.brandSitesV2!.breakpoints.tablet}) {
    display: block;
  }
`;

const TitleMobile = styled.div`
  display: none;

  @media (max-width: ${({ theme }) => theme.brandSitesV2!.breakpoints.mobile}) {
    display: block;
  }
`;

const SubTitle = styled.h2`
  color: #227886;
  font-weight: 500;
  font-size: 26px;
  line-height: 140%;
  margin-bottom: 22px;

  @media (max-width: ${({ theme }) => theme.brandSitesV2!.breakpoints.tablet}) {
    font-size: 22px;
    margin-bottom: 16px;
  }

  @media (max-width: ${({ theme }) => theme.brandSitesV2!.breakpoints.mobile}) {
    font-size: 17px;
    margin-bottom: 19px;
  }
`;

const HeroBottom = styled(motion.div)``;

const Description = styled.p`
  color: rgba(0, 0, 0, 0.6);
  font-weight: 300;
  font-size: 21px;
  line-height: 140%;
  word-break: keep-all;
  max-width: 382px;
  margin-bottom: 50px;
  white-space: pre-line;

  @media (max-width: ${({ theme }) => theme.brandSitesV2!.breakpoints.tablet}) {
    font-size: 17px;
    margin-bottom: 40px;
    max-width: 310px;
  }

  @media (max-width: ${({ theme }) => theme.brandSitesV2!.breakpoints.mobile}) {
    font-weight: 400;
  }
`;

const Button = styled.a`
  display: inline-block;
  font-weight: 500;
  font-size: 16px;
  line-height: 140%;
  border: 1px solid #42484c;
  border-radius: 8px;
  padding: 12px 20px;
  transition: 0.2s;

  @media (max-width: ${({ theme }) => theme.brandSitesV2!.breakpoints.tablet}) {
    font-size: 15px;
    padding: 10px 16px;
  }

  @media (max-width: ${({ theme }) => theme.brandSitesV2!.breakpoints.mobile}) {
    padding: 9px 16px;
  }

  &:hover {
    color: #ffffff;
    background: #42484c;
  }
`;

const TitleDesktopSvg = (
  <svg width="267" height="123" viewBox="0 0 267 123" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M23.326 6.172H7.774V0.609999H23.326V6.172ZM35.638 41.38C35.638 38.248 32.668 36.25 28.726 36.25C24.676 36.25 21.868 38.248 21.868 41.38C21.868 44.566 24.676 46.564 28.726 46.564C32.668 46.564 35.638 44.566 35.638 41.38ZM42.604 30.58H36.016V21.13H28.294V15.73H36.016V0.555999H42.604V30.58ZM28.726 14.38H19.438C20.194 19.888 24.622 22.804 30.238 24.208L27.43 29.554C22.894 28.474 17.386 24.748 15.712 21.13C14.092 24.802 9.178 28.96 3.886 30.58L0.916 25.342C6.208 23.722 11.122 20.158 11.932 14.38H2.32V8.818H28.726V14.38ZM42.172 41.38C42.172 47.806 36.502 52.072 28.726 52.072C20.95 52.072 15.28 47.806 15.28 41.38C15.28 35.17 20.95 30.742 28.726 30.742C36.502 30.742 42.172 35.17 42.172 41.38ZM93.9538 40.624H48.9178V35.116H68.1418V24.91H74.7838V35.116H93.9538V40.624ZM67.6018 1.852H75.2698V4.822C75.2698 13.57 82.8298 18.916 90.7138 21.184L87.7438 26.8C80.1298 24.424 74.3518 20.05 71.4358 14.38C68.6818 20.266 62.5798 24.64 55.1818 26.908L52.2118 21.238C60.2038 19.078 67.6018 13.57 67.6018 4.822V1.852ZM129.374 29.176L129.914 34.468C126.296 34.954 119.222 35.656 114.146 35.926C109.664 36.142 102.968 36.412 98.2156 36.358L97.5676 30.472C101.294 30.58 108.206 30.58 112.904 30.418C118.52 30.256 126.08 29.608 129.374 29.176ZM99.9436 13.948C99.9436 7.252 105.344 2.176 112.904 2.176C120.518 2.176 126.026 7.252 126.026 13.948C126.026 20.59 120.518 25.612 112.904 25.612C105.344 25.612 99.9436 20.59 99.9436 13.948ZM106.424 13.894C106.424 17.404 109.394 20.158 112.904 20.158C116.522 20.158 119.546 17.404 119.546 13.894C119.546 10.33 116.522 7.684 112.904 7.684C109.394 7.684 106.424 10.33 106.424 13.894ZM132.344 45.268V0.663998H138.986V45.268H132.344ZM163.944 3.742H187.758C187.812 18.268 180.036 28.96 165.294 35.062L161.622 29.662C173.286 25.396 179.928 17.188 180.522 9.358H163.944V3.742ZM195.21 45.214V0.663998H201.798V45.214H195.21ZM216.212 35.008H222.854V44.89H247.1V50.398H216.212V35.008ZM235.166 40.084H228.632V30.688H208.76V25.072H253.796V30.688H235.166V40.084ZM231.278 14.002C228.902 18.484 222.638 21.832 216.104 22.696L213.566 17.404C220.424 16.378 226.256 13.246 227.12 8.17H215.51V2.662H246.992V8.17H235.436C236.3 13.246 242.564 16.378 249.044 17.35L246.506 22.588C240.026 21.778 233.762 18.484 231.278 14.002ZM258.436 44.62V37.33H266.212V43.054C266.212 47.806 263.296 51.91 258.49 52.936L257.626 49.75C260.38 49.21 262 46.834 262 44.62H258.436ZM23.326 76.172H7.774V70.61H23.326V76.172ZM35.638 111.38C35.638 108.248 32.668 106.25 28.726 106.25C24.676 106.25 21.868 108.248 21.868 111.38C21.868 114.566 24.676 116.564 28.726 116.564C32.668 116.564 35.638 114.566 35.638 111.38ZM42.604 100.58H36.016V91.13H28.294V85.73H36.016V70.556H42.604V100.58ZM28.726 84.38H19.438C20.194 89.888 24.622 92.804 30.238 94.208L27.43 99.554C22.894 98.474 17.386 94.748 15.712 91.13C14.092 94.802 9.178 98.96 3.886 100.58L0.916 95.342C6.208 93.722 11.122 90.158 11.932 84.38H2.32V78.818H28.726V84.38ZM42.172 111.38C42.172 117.806 36.502 122.072 28.726 122.072C20.95 122.072 15.28 117.806 15.28 111.38C15.28 105.17 20.95 100.742 28.726 100.742C36.502 100.742 42.172 105.17 42.172 111.38ZM93.9538 110.624H48.9178V105.116H68.1418V94.91H74.7838V105.116H93.9538V110.624ZM67.6018 71.852H75.2698V74.822C75.2698 83.57 82.8298 88.916 90.7138 91.184L87.7438 96.8C80.1298 94.424 74.3518 90.05 71.4358 84.38C68.6818 90.266 62.5798 94.64 55.1818 96.908L52.2118 91.238C60.2038 89.078 67.6018 83.57 67.6018 74.822V71.852ZM98.2696 85.73C98.2696 78.764 103.724 73.256 111.5 73.256C115.442 73.256 118.844 74.714 121.22 77.09H133.262V70.664H139.796V105.008H133.262V93.668H121.814C119.438 96.422 115.82 98.096 111.5 98.096C103.724 98.096 98.2696 92.75 98.2696 85.73ZM140.498 119.75H110.258V102.038H116.846V114.08H140.498V119.75ZM104.858 85.676C104.858 89.564 107.666 92.48 111.5 92.48C115.226 92.48 118.088 89.564 118.088 85.676C118.088 81.788 115.226 78.98 111.5 78.98C107.666 78.98 104.858 81.788 104.858 85.676ZM124.514 87.998H133.262V82.814H124.406C124.622 83.786 124.73 84.758 124.73 85.73C124.73 86.54 124.676 87.296 124.514 87.998ZM172.029 118.67H165.333V99.878H146.109V94.154H176.079C177.159 89.51 177.699 82.22 177.483 78.008H152.697V72.338H184.125C184.341 80.33 183.639 88.322 182.397 94.154H191.145V99.878H172.029V118.67ZM239.741 110.624H194.705V105.116H213.929V94.91H220.571V105.116H239.741V110.624ZM213.389 71.852H221.057V74.822C221.057 83.57 228.617 88.916 236.501 91.184L233.531 96.8C225.917 94.424 220.139 90.05 217.223 84.38C214.469 90.266 208.367 94.64 200.969 96.908L197.999 91.238C205.991 89.078 213.389 83.57 213.389 74.822V71.852Z"
      fill="black"
      fillOpacity="0.85"
    />
  </svg>
);

const TitleTabletSvg = (
  <svg width="168" height="77" viewBox="0 0 168 77" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M14.946 3.812H5.154V0.309999H14.946V3.812ZM22.698 25.98C22.698 24.008 20.828 22.75 18.346 22.75C15.796 22.75 14.028 24.008 14.028 25.98C14.028 27.986 15.796 29.244 18.346 29.244C20.828 29.244 22.698 27.986 22.698 25.98ZM27.084 19.18H22.936V13.23H18.074V9.83H22.936V0.276H27.084V19.18ZM18.346 8.98H12.498C12.974 12.448 15.762 14.284 19.298 15.168L17.53 18.534C14.674 17.854 11.206 15.508 10.152 13.23C9.132 15.542 6.038 18.16 2.706 19.18L0.836 15.882C4.168 14.862 7.262 12.618 7.772 8.98H1.72V5.478H18.346V8.98ZM26.812 25.98C26.812 30.026 23.242 32.712 18.346 32.712C13.45 32.712 9.88 30.026 9.88 25.98C9.88 22.07 13.45 19.282 18.346 19.282C23.242 19.282 26.812 22.07 26.812 25.98ZM59.4153 25.504H31.0593V22.036H43.1633V15.61H47.3453V22.036H59.4153V25.504ZM42.8233 1.092H47.6513V2.962C47.6513 8.47 52.4113 11.836 57.3753 13.264L55.5053 16.8C50.7113 15.304 47.0733 12.55 45.2373 8.98C43.5033 12.686 39.6613 15.44 35.0033 16.868L33.1333 13.298C38.1653 11.938 42.8233 8.47 42.8233 2.962V1.092ZM81.7167 18.296L82.0567 21.628C79.7787 21.934 75.3247 22.376 72.1287 22.546C69.3067 22.682 65.0907 22.852 62.0987 22.818L61.6907 19.112C64.0367 19.18 68.3887 19.18 71.3467 19.078C74.8827 18.976 79.6427 18.568 81.7167 18.296ZM63.1867 8.708C63.1867 4.492 66.5867 1.296 71.3467 1.296C76.1407 1.296 79.6087 4.492 79.6087 8.708C79.6087 12.89 76.1407 16.052 71.3467 16.052C66.5867 16.052 63.1867 12.89 63.1867 8.708ZM67.2667 8.674C67.2667 10.884 69.1367 12.618 71.3467 12.618C73.6247 12.618 75.5287 10.884 75.5287 8.674C75.5287 6.43 73.6247 4.764 71.3467 4.764C69.1367 4.764 67.2667 6.43 67.2667 8.674ZM83.5867 28.428V0.343999H87.7687V28.428H83.5867ZM103.483 2.282H118.477C118.511 11.428 113.615 18.16 104.333 22.002L102.021 18.602C109.365 15.916 113.547 10.748 113.921 5.818H103.483V2.282ZM123.169 28.394V0.343999H127.317V28.394H123.169ZM136.393 21.968H140.575V28.19H155.841V31.658H136.393V21.968ZM148.327 25.164H144.213V19.248H131.701V15.712H160.057V19.248H148.327V25.164ZM145.879 8.742C144.383 11.564 140.439 13.672 136.325 14.216L134.727 10.884C139.045 10.238 142.717 8.266 143.261 5.07H135.951V1.602H155.773V5.07H148.497C149.041 8.266 152.985 10.238 157.065 10.85L155.467 14.148C151.387 13.638 147.443 11.564 145.879 8.742ZM162.978 28.02V23.43H167.874V27.034C167.874 30.026 166.038 32.61 163.012 33.256L162.468 31.25C164.202 30.91 165.222 29.414 165.222 28.02H162.978ZM14.946 47.812H5.154V44.31H14.946V47.812ZM22.698 69.98C22.698 68.008 20.828 66.75 18.346 66.75C15.796 66.75 14.028 68.008 14.028 69.98C14.028 71.986 15.796 73.244 18.346 73.244C20.828 73.244 22.698 71.986 22.698 69.98ZM27.084 63.18H22.936V57.23H18.074V53.83H22.936V44.276H27.084V63.18ZM18.346 52.98H12.498C12.974 56.448 15.762 58.284 19.298 59.168L17.53 62.534C14.674 61.854 11.206 59.508 10.152 57.23C9.132 59.542 6.038 62.16 2.706 63.18L0.836 59.882C4.168 58.862 7.262 56.618 7.772 52.98H1.72V49.478H18.346V52.98ZM26.812 69.98C26.812 74.026 23.242 76.712 18.346 76.712C13.45 76.712 9.88 74.026 9.88 69.98C9.88 66.07 13.45 63.282 18.346 63.282C23.242 63.282 26.812 66.07 26.812 69.98ZM59.4153 69.504H31.0593V66.036H43.1633V59.61H47.3453V66.036H59.4153V69.504ZM42.8233 45.092H47.6513V46.962C47.6513 52.47 52.4113 55.836 57.3753 57.264L55.5053 60.8C50.7113 59.304 47.0733 56.55 45.2373 52.98C43.5033 56.686 39.6613 59.44 35.0033 60.868L33.1333 57.298C38.1653 55.938 42.8233 52.47 42.8233 46.962V45.092ZM62.1327 53.83C62.1327 49.444 65.5667 45.976 70.4627 45.976C72.9447 45.976 75.0867 46.894 76.5827 48.39H84.1647V44.344H88.2787V65.968H84.1647V58.828H76.9567C75.4607 60.562 73.1827 61.616 70.4627 61.616C65.5667 61.616 62.1327 58.25 62.1327 53.83ZM88.7207 75.25H69.6807V64.098H73.8287V71.68H88.7207V75.25ZM66.2807 53.796C66.2807 56.244 68.0487 58.08 70.4627 58.08C72.8087 58.08 74.6107 56.244 74.6107 53.796C74.6107 51.348 72.8087 49.58 70.4627 49.58C68.0487 49.58 66.2807 51.348 66.2807 53.796ZM78.6567 55.258H84.1647V51.994H78.5887C78.7247 52.606 78.7927 53.218 78.7927 53.83C78.7927 54.34 78.7587 54.816 78.6567 55.258ZM108.574 74.57H104.358V62.738H92.254V59.134H111.124C111.804 56.21 112.144 51.62 112.008 48.968H96.402V45.398H116.19C116.326 50.43 115.884 55.462 115.102 59.134H120.61V62.738H108.574V74.57ZM151.207 69.504H122.851V66.036H134.955V59.61H139.137V66.036H151.207V69.504ZM134.615 45.092H139.443V46.962C139.443 52.47 144.203 55.836 149.167 57.264L147.297 60.8C142.503 59.304 138.865 56.55 137.029 52.98C135.295 56.686 131.453 59.44 126.795 60.868L124.925 57.298C129.957 55.938 134.615 52.47 134.615 46.962V45.092Z"
      fill="black"
      fillOpacity="0.85"
    />
  </svg>
);

const TitleMobileSvg = (
  <svg width="162" height="77" viewBox="0 0 162 77" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M14.946 3.812V0.309999H5.154V3.812H14.946ZM22.698 25.98C22.698 27.986 20.828 29.244 18.346 29.244C15.796 29.244 14.028 27.986 14.028 25.98C14.028 24.008 15.796 22.75 18.346 22.75C20.828 22.75 22.698 24.008 22.698 25.98ZM27.084 19.18V0.276H22.936V9.83H18.074V13.23H22.936V19.18H27.084ZM18.346 8.98V5.478H1.72V8.98H7.772C7.262 12.618 4.168 14.862 0.836 15.882L2.706 19.18C6.038 18.16 9.132 15.542 10.152 13.23C11.206 15.508 14.674 17.854 17.53 18.534L19.298 15.168C15.762 14.284 12.974 12.448 12.498 8.98H18.346ZM26.812 25.98C26.812 22.07 23.242 19.282 18.346 19.282C13.45 19.282 9.88 22.07 9.88 25.98C9.88 30.026 13.45 32.712 18.346 32.712C23.242 32.712 26.812 30.026 26.812 25.98ZM59.4153 25.504V22.036H47.3453V15.61H43.1633V22.036H31.0593V25.504H59.4153ZM42.8233 1.092V2.962C42.8233 8.47 38.1653 11.938 33.1333 13.298L35.0033 16.868C39.6613 15.44 43.5033 12.686 45.2373 8.98C47.0733 12.55 50.7113 15.304 55.5053 16.8L57.3753 13.264C52.4113 11.836 47.6513 8.47 47.6513 2.962V1.092H42.8233ZM73.5567 28.564H70.3607V25.606H73.5567V28.564ZM66.6887 8.742C66.6887 6.396 68.4227 4.764 70.7347 4.764C73.0467 4.764 74.8147 6.396 74.8147 8.742C74.8147 11.122 73.0467 12.754 70.7347 12.754C68.4227 12.754 66.6887 11.122 66.6887 8.742ZM77.4667 31.964V30.128L79.2687 32.406C81.5807 31.25 83.4507 29.074 84.3007 26.898C85.0827 29.04 87.2587 31.386 89.1967 32.236L91.4747 29.244C87.9727 27.578 86.3747 24.28 86.3747 20.846V18.704H82.2607V21.084C82.2607 24.484 80.4927 27.442 77.4667 29.006V18.772H73.5567V22.24H70.3607V18.772H66.4507V31.964H77.4667ZM62.6087 8.776C62.6087 13.026 65.9747 16.324 70.7347 16.324C74.9167 16.324 78.0447 13.774 78.7247 10.238H84.0967V17.14H88.2787V0.309999H84.0967V6.77H78.5887C77.7047 3.54 74.7127 1.228 70.7347 1.228C65.9747 1.228 62.6087 4.56 62.6087 8.776ZM120.61 18.568V15.032H92.254V18.568H120.61ZM96.98 0.615999V12.108H116.326V8.606H101.162V0.615999H96.98ZM96.81 20.914V31.318H116.292V27.816H100.992V20.914H96.81ZM1.924 46.282V49.818H12.226C11.75 54.748 7.738 59.916 0.462 62.602L2.74 66.002C12.056 62.16 16.612 55.428 16.578 46.282H1.924ZM29.974 56.788V53.32H24.976V44.344H20.76V72.394H24.976V56.788H29.974ZM47.3113 64.268V60.46H53.5673V72.428H57.7153V44.344H53.5673V49.512H47.3113V45.738H43.1633V51.756H36.5333V45.738H32.3853V64.268H47.3113ZM43.1633 60.766H36.5333V55.292H43.1633V60.766ZM47.3113 56.958V53.014H53.5673V56.958H47.3113ZM80.6627 51.45C80.6627 53.592 78.6227 55.122 75.8347 55.122C72.9447 55.122 71.0067 53.592 71.0067 51.45C71.0067 49.342 72.9787 47.812 75.8347 47.812C78.6227 47.812 80.6627 49.342 80.6627 51.45ZM66.3487 66.41V75.964H85.8307V72.496H70.5307V66.41H66.3487ZM78.5207 69.13V63.69H90.0127V60.188H61.6567V63.69H74.4067V69.13H78.5207ZM84.7087 51.45C84.7087 47.132 80.7647 44.344 75.8347 44.344C71.0407 44.344 66.9607 47.098 66.9607 51.45C66.9607 56.21 71.3467 58.522 75.8347 58.522C80.2887 58.522 84.7087 56.176 84.7087 51.45ZM102.157 52.504C102.157 56.686 105.591 59.916 110.385 59.916C115.281 59.916 118.783 56.686 118.783 52.504C118.783 48.322 115.281 45.092 110.385 45.092C105.591 45.092 102.157 48.322 102.157 52.504ZM106.271 52.47C106.271 50.192 108.039 48.628 110.385 48.628C112.799 48.628 114.669 50.192 114.669 52.47C114.669 54.782 112.799 56.346 110.385 56.346C108.039 56.346 106.271 54.782 106.271 52.47ZM127.759 60.222V44.31H123.577V60.222H127.759ZM128.235 76.372V72.904H113.207V70.932H127.759V61.786H109.093V65.288H123.645V67.43H109.093V76.372H128.235ZM149.551 57.638C145.913 56.38 142.445 52.436 142.445 47.812V45.092H138.059V47.88C138.059 52.708 134.829 56.686 130.783 58.692L133.265 61.684C136.529 60.154 139.283 57.094 140.405 54.306C141.663 57.026 144.485 59.644 147.307 60.8L149.551 57.638ZM152.271 69.198C152.271 71.442 150.401 72.938 147.851 72.938C145.301 72.938 143.533 71.442 143.533 69.198C143.533 67.022 145.301 65.492 147.851 65.492C150.401 65.492 152.271 67.022 152.271 69.198ZM156.385 69.198C156.385 65.084 152.815 62.024 147.851 62.024C142.955 62.024 139.385 65.084 139.385 69.198C139.385 73.584 142.955 76.406 147.851 76.406C152.815 76.406 156.385 73.584 156.385 69.198ZM161.213 54.85V51.348H156.215V44.31H152.067V61.65H156.215V54.85H161.213Z"
      fill="black"
      fillOpacity="0.85"
    />
  </svg>
);
